/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.apibuffers.AuthSystemType', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateLoadClaimsRequest', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateLoadClaimsResponse', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateReferrer', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateReferrerType', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateRequest', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateResetRequest', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateSignupRequest', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateStatus', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateVerifyRequest', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticateVerifyResponse', null, global);
goog.exportSymbol('proto.apibuffers.AuthenticationResponse', null, global);
goog.exportSymbol('proto.apibuffers.GuestRequest', null, global);
goog.exportSymbol('proto.apibuffers.LoginRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.LoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.LoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.LoginRequest.displayName = 'proto.apibuffers.LoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateReferrer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateReferrer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateReferrer.displayName = 'proto.apibuffers.AuthenticateReferrer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateRequest.displayName = 'proto.apibuffers.AuthenticateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.GuestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.GuestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.GuestRequest.displayName = 'proto.apibuffers.GuestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticationResponse.displayName = 'proto.apibuffers.AuthenticationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateSignupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateSignupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateSignupRequest.displayName = 'proto.apibuffers.AuthenticateSignupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateLoadClaimsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateLoadClaimsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateLoadClaimsRequest.displayName = 'proto.apibuffers.AuthenticateLoadClaimsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateLoadClaimsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.AuthenticateLoadClaimsResponse.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.AuthenticateLoadClaimsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateLoadClaimsResponse.displayName = 'proto.apibuffers.AuthenticateLoadClaimsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateResetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateResetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateResetRequest.displayName = 'proto.apibuffers.AuthenticateResetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateVerifyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateVerifyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateVerifyRequest.displayName = 'proto.apibuffers.AuthenticateVerifyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.AuthenticateVerifyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.AuthenticateVerifyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.AuthenticateVerifyResponse.displayName = 'proto.apibuffers.AuthenticateVerifyResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.LoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.LoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.LoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    password: jspb.Message.getFieldWithDefault(msg, 3, ""),
    deviceInfo: (f = msg.getDeviceInfo()) && common_pb.DeviceInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.LoginRequest}
 */
proto.apibuffers.LoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.LoginRequest;
  return proto.apibuffers.LoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.LoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.LoginRequest}
 */
proto.apibuffers.LoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = new common_pb.DeviceInfo;
      reader.readMessage(value,common_pb.DeviceInfo.deserializeBinaryFromReader);
      msg.setDeviceInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.LoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.LoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.LoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.LoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDeviceInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.DeviceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string application_id = 1;
 * @return {string}
 */
proto.apibuffers.LoginRequest.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.LoginRequest.prototype.setApplicationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.apibuffers.LoginRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.LoginRequest.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.apibuffers.LoginRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.LoginRequest.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DeviceInfo device_info = 4;
 * @return {?proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.LoginRequest.prototype.getDeviceInfo = function() {
  return /** @type{?proto.apibuffers.DeviceInfo} */ (
    jspb.Message.getWrapperField(this, common_pb.DeviceInfo, 4));
};


/** @param {?proto.apibuffers.DeviceInfo|undefined} value */
proto.apibuffers.LoginRequest.prototype.setDeviceInfo = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.LoginRequest.prototype.clearDeviceInfo = function() {
  this.setDeviceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.LoginRequest.prototype.hasDeviceInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateReferrer.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateReferrer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateReferrer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateReferrer.toObject = function(includeInstance, msg) {
  var f, obj = {
    referrerType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    referrer: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateReferrer}
 */
proto.apibuffers.AuthenticateReferrer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateReferrer;
  return proto.apibuffers.AuthenticateReferrer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateReferrer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateReferrer}
 */
proto.apibuffers.AuthenticateReferrer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.AuthenticateReferrerType} */ (reader.readEnum());
      msg.setReferrerType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateReferrer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateReferrer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateReferrer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateReferrer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferrerType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional AuthenticateReferrerType referrer_type = 1;
 * @return {!proto.apibuffers.AuthenticateReferrerType}
 */
proto.apibuffers.AuthenticateReferrer.prototype.getReferrerType = function() {
  return /** @type {!proto.apibuffers.AuthenticateReferrerType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.AuthenticateReferrerType} value */
proto.apibuffers.AuthenticateReferrer.prototype.setReferrerType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string referrer = 2;
 * @return {string}
 */
proto.apibuffers.AuthenticateReferrer.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateReferrer.prototype.setReferrer = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    system: jspb.Message.getFieldWithDefault(msg, 2, 0),
    token: jspb.Message.getFieldWithDefault(msg, 3, ""),
    deviceInfo: (f = msg.getDeviceInfo()) && common_pb.DeviceInfo.toObject(includeInstance, f),
    referrer: (f = msg.getReferrer()) && proto.apibuffers.AuthenticateReferrer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateRequest}
 */
proto.apibuffers.AuthenticateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateRequest;
  return proto.apibuffers.AuthenticateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateRequest}
 */
proto.apibuffers.AuthenticateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.AuthSystemType} */ (reader.readEnum());
      msg.setSystem(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 4:
      var value = new common_pb.DeviceInfo;
      reader.readMessage(value,common_pb.DeviceInfo.deserializeBinaryFromReader);
      msg.setDeviceInfo(value);
      break;
    case 5:
      var value = new proto.apibuffers.AuthenticateReferrer;
      reader.readMessage(value,proto.apibuffers.AuthenticateReferrer.deserializeBinaryFromReader);
      msg.setReferrer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSystem();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDeviceInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.DeviceInfo.serializeBinaryToWriter
    );
  }
  f = message.getReferrer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.apibuffers.AuthenticateReferrer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string application_id = 1;
 * @return {string}
 */
proto.apibuffers.AuthenticateRequest.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateRequest.prototype.setApplicationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AuthSystemType system = 2;
 * @return {!proto.apibuffers.AuthSystemType}
 */
proto.apibuffers.AuthenticateRequest.prototype.getSystem = function() {
  return /** @type {!proto.apibuffers.AuthSystemType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.AuthSystemType} value */
proto.apibuffers.AuthenticateRequest.prototype.setSystem = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string token = 3;
 * @return {string}
 */
proto.apibuffers.AuthenticateRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateRequest.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DeviceInfo device_info = 4;
 * @return {?proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.AuthenticateRequest.prototype.getDeviceInfo = function() {
  return /** @type{?proto.apibuffers.DeviceInfo} */ (
    jspb.Message.getWrapperField(this, common_pb.DeviceInfo, 4));
};


/** @param {?proto.apibuffers.DeviceInfo|undefined} value */
proto.apibuffers.AuthenticateRequest.prototype.setDeviceInfo = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.AuthenticateRequest.prototype.clearDeviceInfo = function() {
  this.setDeviceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.AuthenticateRequest.prototype.hasDeviceInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AuthenticateReferrer referrer = 5;
 * @return {?proto.apibuffers.AuthenticateReferrer}
 */
proto.apibuffers.AuthenticateRequest.prototype.getReferrer = function() {
  return /** @type{?proto.apibuffers.AuthenticateReferrer} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.AuthenticateReferrer, 5));
};


/** @param {?proto.apibuffers.AuthenticateReferrer|undefined} value */
proto.apibuffers.AuthenticateRequest.prototype.setReferrer = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.AuthenticateRequest.prototype.clearReferrer = function() {
  this.setReferrer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.AuthenticateRequest.prototype.hasReferrer = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.GuestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.GuestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.GuestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.GuestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deviceInfo: (f = msg.getDeviceInfo()) && common_pb.DeviceInfo.toObject(includeInstance, f),
    referrer: (f = msg.getReferrer()) && proto.apibuffers.AuthenticateReferrer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.GuestRequest}
 */
proto.apibuffers.GuestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.GuestRequest;
  return proto.apibuffers.GuestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.GuestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.GuestRequest}
 */
proto.apibuffers.GuestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 2:
      var value = new common_pb.DeviceInfo;
      reader.readMessage(value,common_pb.DeviceInfo.deserializeBinaryFromReader);
      msg.setDeviceInfo(value);
      break;
    case 3:
      var value = new proto.apibuffers.AuthenticateReferrer;
      reader.readMessage(value,proto.apibuffers.AuthenticateReferrer.deserializeBinaryFromReader);
      msg.setReferrer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.GuestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.GuestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.GuestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.GuestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeviceInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.DeviceInfo.serializeBinaryToWriter
    );
  }
  f = message.getReferrer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.apibuffers.AuthenticateReferrer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string application_id = 1;
 * @return {string}
 */
proto.apibuffers.GuestRequest.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.GuestRequest.prototype.setApplicationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceInfo device_info = 2;
 * @return {?proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.GuestRequest.prototype.getDeviceInfo = function() {
  return /** @type{?proto.apibuffers.DeviceInfo} */ (
    jspb.Message.getWrapperField(this, common_pb.DeviceInfo, 2));
};


/** @param {?proto.apibuffers.DeviceInfo|undefined} value */
proto.apibuffers.GuestRequest.prototype.setDeviceInfo = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.GuestRequest.prototype.clearDeviceInfo = function() {
  this.setDeviceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.GuestRequest.prototype.hasDeviceInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AuthenticateReferrer referrer = 3;
 * @return {?proto.apibuffers.AuthenticateReferrer}
 */
proto.apibuffers.GuestRequest.prototype.getReferrer = function() {
  return /** @type{?proto.apibuffers.AuthenticateReferrer} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.AuthenticateReferrer, 3));
};


/** @param {?proto.apibuffers.AuthenticateReferrer|undefined} value */
proto.apibuffers.GuestRequest.prototype.setReferrer = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.GuestRequest.prototype.clearReferrer = function() {
  this.setReferrer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.GuestRequest.prototype.hasReferrer = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expires: (f = msg.getExpires()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    responseStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticationResponse}
 */
proto.apibuffers.AuthenticationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticationResponse;
  return proto.apibuffers.AuthenticationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticationResponse}
 */
proto.apibuffers.AuthenticationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpires(value);
      break;
    case 3:
      var value = /** @type {!proto.apibuffers.AuthenticateStatus} */ (reader.readEnum());
      msg.setResponseStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpires();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getResponseStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.apibuffers.AuthenticationResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticationResponse.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp expires = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.apibuffers.AuthenticationResponse.prototype.getExpires = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.apibuffers.AuthenticationResponse.prototype.setExpires = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.AuthenticationResponse.prototype.clearExpires = function() {
  this.setExpires(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.AuthenticationResponse.prototype.hasExpires = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AuthenticateStatus response_status = 3;
 * @return {!proto.apibuffers.AuthenticateStatus}
 */
proto.apibuffers.AuthenticationResponse.prototype.getResponseStatus = function() {
  return /** @type {!proto.apibuffers.AuthenticateStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.apibuffers.AuthenticateStatus} value */
proto.apibuffers.AuthenticationResponse.prototype.setResponseStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateSignupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateSignupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateSignupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, ""),
    referrer: (f = msg.getReferrer()) && proto.apibuffers.AuthenticateReferrer.toObject(includeInstance, f),
    deviceInfo: (f = msg.getDeviceInfo()) && common_pb.DeviceInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateSignupRequest}
 */
proto.apibuffers.AuthenticateSignupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateSignupRequest;
  return proto.apibuffers.AuthenticateSignupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateSignupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateSignupRequest}
 */
proto.apibuffers.AuthenticateSignupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 5:
      var value = new proto.apibuffers.AuthenticateReferrer;
      reader.readMessage(value,proto.apibuffers.AuthenticateReferrer.deserializeBinaryFromReader);
      msg.setReferrer(value);
      break;
    case 6:
      var value = new common_pb.DeviceInfo;
      reader.readMessage(value,common_pb.DeviceInfo.deserializeBinaryFromReader);
      msg.setDeviceInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateSignupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateSignupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateSignupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReferrer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.apibuffers.AuthenticateReferrer.serializeBinaryToWriter
    );
  }
  f = message.getDeviceInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.DeviceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string application_id = 1;
 * @return {string}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setApplicationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional AuthenticateReferrer referrer = 5;
 * @return {?proto.apibuffers.AuthenticateReferrer}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getReferrer = function() {
  return /** @type{?proto.apibuffers.AuthenticateReferrer} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.AuthenticateReferrer, 5));
};


/** @param {?proto.apibuffers.AuthenticateReferrer|undefined} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setReferrer = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.clearReferrer = function() {
  this.setReferrer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.hasReferrer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DeviceInfo device_info = 6;
 * @return {?proto.apibuffers.DeviceInfo}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.getDeviceInfo = function() {
  return /** @type{?proto.apibuffers.DeviceInfo} */ (
    jspb.Message.getWrapperField(this, common_pb.DeviceInfo, 6));
};


/** @param {?proto.apibuffers.DeviceInfo|undefined} value */
proto.apibuffers.AuthenticateSignupRequest.prototype.setDeviceInfo = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.clearDeviceInfo = function() {
  this.setDeviceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.AuthenticateSignupRequest.prototype.hasDeviceInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateLoadClaimsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateLoadClaimsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    system: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateLoadClaimsRequest}
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateLoadClaimsRequest;
  return proto.apibuffers.AuthenticateLoadClaimsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateLoadClaimsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateLoadClaimsRequest}
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.AuthSystemType} */ (reader.readEnum());
      msg.setSystem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateLoadClaimsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateLoadClaimsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystem();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional AuthSystemType system = 1;
 * @return {!proto.apibuffers.AuthSystemType}
 */
proto.apibuffers.AuthenticateLoadClaimsRequest.prototype.getSystem = function() {
  return /** @type {!proto.apibuffers.AuthSystemType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.AuthSystemType} value */
proto.apibuffers.AuthenticateLoadClaimsRequest.prototype.setSystem = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateLoadClaimsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateLoadClaimsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    claimsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateLoadClaimsResponse}
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateLoadClaimsResponse;
  return proto.apibuffers.AuthenticateLoadClaimsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateLoadClaimsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateLoadClaimsResponse}
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addClaims(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateLoadClaimsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateLoadClaimsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string claims = 1;
 * @return {!Array<string>}
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.getClaimsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.setClaimsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.addClaims = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.AuthenticateLoadClaimsResponse.prototype.clearClaimsList = function() {
  this.setClaimsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateResetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateResetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateResetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateResetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateResetRequest}
 */
proto.apibuffers.AuthenticateResetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateResetRequest;
  return proto.apibuffers.AuthenticateResetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateResetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateResetRequest}
 */
proto.apibuffers.AuthenticateResetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateResetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateResetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateResetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateResetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string application_id = 1;
 * @return {string}
 */
proto.apibuffers.AuthenticateResetRequest.prototype.getApplicationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateResetRequest.prototype.setApplicationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.apibuffers.AuthenticateResetRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.AuthenticateResetRequest.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateVerifyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateVerifyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateVerifyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateVerifyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateVerifyRequest}
 */
proto.apibuffers.AuthenticateVerifyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateVerifyRequest;
  return proto.apibuffers.AuthenticateVerifyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateVerifyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateVerifyRequest}
 */
proto.apibuffers.AuthenticateVerifyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateVerifyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateVerifyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateVerifyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateVerifyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.AuthenticateVerifyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.AuthenticateVerifyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.AuthenticateVerifyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateVerifyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.AuthenticateVerifyResponse}
 */
proto.apibuffers.AuthenticateVerifyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.AuthenticateVerifyResponse;
  return proto.apibuffers.AuthenticateVerifyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.AuthenticateVerifyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.AuthenticateVerifyResponse}
 */
proto.apibuffers.AuthenticateVerifyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.AuthenticateVerifyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.AuthenticateVerifyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.AuthenticateVerifyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.AuthenticateVerifyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.apibuffers.AuthSystemType = {
  FACEBOOK: 0,
  GOOGLE: 1,
  INSTAGRAM: 2,
  TWITTER: 3,
  FACEBOOK_PUBLISH: 5,
  TWITTER_PUBLISH: 6
};

/**
 * @enum {number}
 */
proto.apibuffers.AuthenticateStatus = {
  USER_STATUS_UNKNOWN: 0,
  USER_CREATED: 1,
  USER_LOGGED_IN: 2,
  ERROR_USER_NOT_FOUND: 3,
  ERROR_INVALID_AUTH_TOKEN: 4,
  ERROR_EXPIRED_AUTH_TOKEN: 5,
  ERROR_INVALID_EMAIL: 6,
  ERROR_INVALID_PASSWORD: 7,
  ERROR_INCORRECT_PASSWORD: 8,
  ERROR_INVALID_USERNAME: 9,
  ERROR_EMAIL_ALREADY_EXISTS: 10,
  PASSWORD_RESET: 11
};

/**
 * @enum {number}
 */
proto.apibuffers.AuthenticateReferrerType = {
  USER: 0
};

goog.object.extend(exports, proto.apibuffers);
